import React from 'react'
import Topbar from '../components/Layout/Topbar'
import DeliveryOrder from '../components/CreateDeliveryOrder.js/DeliveryOrder'
import { Sidebar } from '../components/Layout/Sidebar'

const CreateDeliveryOrder = () => {
  return (
    <div className='crm-app-shell flex min-h-screen gap-3 p-3'>
        <Sidebar />
        <div className='crm-page-scroll flex min-w-0 flex-1 flex-col'>
          <Topbar />
          <DeliveryOrder />
        </div>
    </div>
  )
}

export default CreateDeliveryOrder
